<template>
    <div v-if="number" :class="sizeClass" class="position-absolute btn-notif bg-secondary-darken-1 text-white text-caption rounded-lg">
        {{ number }}</div>
</template>

<script setup>
const props = defineProps({ number: Number, size: String });

const sizeClass = computed(() => {
    const className = `notif-${props.size}`;

    return { [className]: props.size };
});
</script>

<style scoped>
.btn-notif {
    padding: 0px 5px !important;

    &.notif-small {
        padding: 0px 4px !important;
        border-radius: 50%;
        font-size: x-small;
    }
}
</style>
